import Button from '../button/Button';
import FilterSidebar from './FilterSidebar';
import OptionsPanel from './OptionsPanel';
import { MultiFieldFilterV2Props } from './types';
import useMultiFieldFilter from './useMultiFieldFilter';

const MultiFieldFilterV2 = ({
  fieldOptions,
  onApply,
  selectedFilters,
  buttonClass,
  type = 'multi',
  customFields,
  setCustomFields
}: MultiFieldFilterV2Props) => {
  const {
    isOpen,
    open,
    close,
    activeField,
    selectField,
    selected,
    selectAllModes,
    excludedItems,
    isSelectAllMode,
    isAllSelected,
    totalSelected,
    currentField,
    isSingleSelect,
    hasOptions,
    searchTerms,
    handleSearch,
    dateRange,
    handleDateChange,
    toggleItem,
    toggleSelectAll,
    handleOptionsScroll,
    handleApply,
    handleClear,
    containerRef,
    optionsScrollRef
  } = useMultiFieldFilter({
    fieldOptions,
    onApply,
    selectedFilters,
    type,
    customFields,
    setCustomFields
  });

  return (
    <div className="relative" ref={containerRef}>
      <div className="relative">
        <Button
          variant="tertiary"
          handleClick={() => (isOpen ? close() : open())}
          size="medium"
          label="Filter"
          className={`ml-auto w-24 justify-between ${buttonClass || ''}`}
          leftIconName="filter"
        />
        {type === 'multi' && totalSelected > 0 && (
          <div className="absolute -right-1.5 -top-1.5 flex size-5 items-center justify-center rounded-xl bg-primary text-xs text-theme">
            {totalSelected}
          </div>
        )}
      </div>

      {isOpen && (
        <div className="absolute right-0 z-50 mt-1 flex h-[485px] w-[616px] overflow-hidden rounded-xl border border-greyStroke bg-white shadow-multiFieldFilterShadow">
          <div className="flex w-[300px] shrink-0 flex-col">
            <FilterSidebar
              fieldOptions={fieldOptions}
              activeField={activeField}
              selected={selected}
              selectAllModes={selectAllModes}
              excludedItems={excludedItems}
              type={type}
              onSelectField={selectField}
            />
            <div className="flex shrink-0 items-center justify-end gap-4 border-t border-greyStroke px-4 py-3">
              <Button
                label="Clear"
                variant="tertiary"
                handleClick={handleClear}
                className="!h-10 !w-25"
              />
              <Button
                label="Apply"
                handleClick={handleApply}
                className="!h-10 !w-25"
              />
            </div>
          </div>
          <OptionsPanel
            currentField={currentField}
            activeField={activeField}
            isSingleSelect={isSingleSelect}
            hasOptions={hasOptions}
            isSelectAllMode={isSelectAllMode}
            isAllSelected={isAllSelected}
            selected={selected}
            excludedItems={excludedItems}
            searchTerms={searchTerms}
            dateRange={dateRange}
            optionsScrollRef={optionsScrollRef}
            onSearch={handleSearch}
            onScroll={handleOptionsScroll}
            onToggleItem={toggleItem}
            onToggleSelectAll={toggleSelectAll}
            onDateChange={handleDateChange}
          />
        </div>
      )}
    </div>
  );
};

export default MultiFieldFilterV2;
